import { CalculationFrequency } from 'components/BenchmarkMetadata/components/BenchmarkForm/BenchmarkForm';
import { dateToServer } from 'helpers/formatters/date';
import {
  AbsoluteReturnTimeWindow,
  AbsoluteReturnTimeWindowForm,
} from 'types/AbsoluteReturn';
import { BenchmarkTypes } from 'types/Benchmark';

const mapTimeWindow = (data: AbsoluteReturnTimeWindowForm) => {
  const timeWindow: AbsoluteReturnTimeWindow = {
    fromDate: dateToServer(new Date(data.fromDate)),
    basisPointAdjustment: data.basisPointAdjustment,
  };
  if (!data.noReturnComponent) {
    if (
      typeof data.returnComponent === 'string' &&
      data.returnComponent.includes('-')
    ) {
      timeWindow.returnComponentBenchmarkId = data.returnComponent;
    } else {
      timeWindow.returnComponentResourceId = Number(data.returnComponent);
    }
  }
  return timeWindow;
};

const parseBoolean = (value: string | boolean): boolean => {
  switch (typeof value) {
    case 'string':
      return JSON.parse(value);

    case 'boolean':
    default:
      return value;
  }
};

export function getBody(originalValues: any, newValues: any) {
  const timeWindows = newValues.timeWindows
    ? newValues.timeWindows.map(mapTimeWindow)
    : [];

  return {
    id: originalValues?.id,
    typeId: BenchmarkTypes.AbsoluteReturn,
    name: newValues.name,
    baseCurrencyCode: newValues.baseCurrencyCode,
    calculationFrequencyId:
      newValues.calculationFrequency?.id ?? newValues.calculationFrequencyId,
    numberOfDaysInYearId:
      newValues.numberOfDaysInYearId !== undefined
        ? Number(newValues.numberOfDaysInYearId)
        : undefined,
    isLagged: parseBoolean(newValues.isLagged) ? true : false,
    useDailyToMonthlyLinking: parseBoolean(newValues.useDailyToMonthlyLinking)
      ? true
      : false,
    customLagDate: newValues.customLagDate || null,
    description: newValues.description || null,
    portfolioAnalyticsCalendarId:
      newValues.calculationFrequencyId === CalculationFrequency.day ||
        newValues.calculationFrequency?.id === CalculationFrequency.day
        ? newValues.portfolioAnalyticsCalendarId
        : undefined,
    includeBookedValues: parseBoolean(newValues.includeBookedValues)
      ? true
      : false,
    timeWindows,
  };
}
